var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "percent-indicator" }, [
    _c(
      "svg",
      {
        staticStyle: { overflow: "visible" },
        attrs: {
          width: "133",
          height: "133",
          viewBox: "0 0 133 133",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c(
          "defs",
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "gradient",
                  gradientUnits: "userSpaceOnUse",
                  x1: "0",
                  y1: "133",
                  x2: "0",
                  y2: "0"
                }
              },
              [
                _c("stop", {
                  attrs: { offset: "0%", "stop-color": "#F8B9E5" }
                }),
                _c("stop", {
                  attrs: { offset: "50%", "stop-color": "#FDB08D" }
                }),
                _c("stop", {
                  attrs: { offset: "100%", "stop-color": "#F9F6A2" }
                })
              ],
              1
            ),
            _c(
              "filter",
              {
                attrs: {
                  id: "filter0_ddd",
                  x: "-30",
                  y: "-30",
                  width: "193",
                  height: "193",
                  filterUnits: "userSpaceOnUse"
                }
              },
              [
                _c("feFlood", {
                  attrs: { "flood-opacity": "0", result: "BG" }
                }),
                _c("feColorMatrix", {
                  attrs: {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0   0 0 0 127 0",
                    result: "HA"
                  }
                }),
                _c("feOffset", { attrs: { dx: "3", dy: "3" } }),
                _c("feGaussianBlur", { attrs: { stdDeviation: "3.87" } }),
                _c("feColorMatrix", {
                  attrs: {
                    type: "matrix",
                    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0   0 0 0 0.2 0"
                  }
                }),
                _c("feBlend", {
                  attrs: { in2: "BG", mode: "normal", result: "drop1" }
                }),
                _c("feOffset", { attrs: { dx: "-1.55", dy: "-1.55" } }),
                _c("feGaussianBlur", { attrs: { stdDeviation: "1.55" } }),
                _c("feColorMatrix", {
                  attrs: {
                    type: "matrix",
                    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1   0 0 0 1 0"
                  }
                }),
                _c("feBlend", {
                  attrs: { in2: "drop1", mode: "normal", result: "drop2" }
                }),
                _c("feBlend", {
                  attrs: { in: "SourceGraphic", in2: "drop2", mode: "normal" }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("g", { attrs: { filter: "url(#filter0_ddd)" } }, [
          _c("path", { attrs: { d: _vm.originalPath, fill: "#FDFEFE" } })
        ]),
        _c(
          "g",
          {
            attrs: {
              transform:
                "translate(" +
                _vm.center.x +
                "," +
                _vm.center.y +
                ") scale(" +
                _vm.scale +
                ") translate(" +
                -_vm.center.x +
                "," +
                -_vm.center.y +
                ")"
            }
          },
          [
            _c("path", {
              staticStyle: { transition: "stroke-dasharray 1s ease-in-out" },
              attrs: {
                d: _vm.targetPath,
                fill: "none",
                stroke: "url(#gradient)",
                "stroke-width": "8",
                "stroke-linecap": "round",
                "vector-effect": "non-scaling-stroke",
                "stroke-dasharray": _vm.getStrokeDashArray(
                  _vm.animatedPercentage
                )
              }
            })
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }